import gql from 'graphql-tag'

export const USUARIO_BY_CPF_QUERY = gql`
  query UsuarioByCpfQuery($cpf: String!) {
    usuarioByCpf(cpf: $cpf) {
      id
      nome
      cpf
    }
  }
`
